import { classToPlain, plainToClass } from 'class-transformer';
import { TUserId } from '../../../PartyClientResponse';
import { GameState, GameType } from './GameModel';

export interface ICreateGameViewModel {
  type: GameType;
  typeTitle: string;
  displayName: string;
  state: GameState;
  stateTitle: string;
  ownerId: TUserId;
}

export default class CreateGameViewModel {
  static fromJson(json: ICreateGameViewModel) {
    return plainToClass(this, json);
  }

  public toJson() {
    return classToPlain(this);
  }

  type!: GameType;
  typeTitle!: string;
  displayName!: string;
  state!: GameState;
  stateTitle!: string;
  ownerId!: TUserId;
}
